import type { Orientation } from '../../core/components/canvas/types/canvas-shape.js';
import type { LINEAR_ACCESSORS } from '../components/displays/index.js';
import type { XYChartAreaVariant } from '../types/xy-chart-internals.js';

export function resolveAreaAccessKey(
  variant: XYChartAreaVariant,
  orientation: Orientation,
): keyof typeof LINEAR_ACCESSORS {
  return `${variant}${orientation}`;
}
